
import style from "./NotFound.module.css";

function NotFound() {

    return (
        <section id={ style.nf_section }>OOps!<br />The webpage cannot be displayed.</section>
    )

}

export default NotFound;